import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { getAdvBuilds } from "@ugg/shared/api/data-parser/champions/adv-builds";
import { useChampionRecBuild } from "@ugg/shared/api/requests/champions/adv-builds";
import { ChampionProfilePagePlaceholder } from "@ugg/shared/components/Champions/ChampionProfilePagePlaceholder";
import { ChampionProfilePageError } from "@ugg/shared/components/Champions/ChampionProfilePageError";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { SpellsTable } from "./SpellsTable";
import { AbilitiesTable } from "./AbilitiesTable";

export function SpellsAbilitiesContainer({ className, ssr }: { className?: string; ssr?: boolean }) {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.SPELLS_ABILITIES, queryParams, true);
  const { data, loading, error } = useChampionRecBuild(championId, CHAMPION_PAGES.SPELLS_ABILITIES, {
    params: validatedQueryParams,
    ssr,
  });
  const recommendedBuild = getAdvBuilds(data, { ...validatedQueryParams, role: normalizeRole(role || "") });
  const { summoner_spells, skills } = recommendedBuild || {};

  if (loading) {
    return <ChampionProfilePagePlaceholder className="w-full" />;
  } else if (error || !summoner_spells || !skills) {
    return <ChampionProfilePageError className="w-full" />;
  }

  return (
    <div className="flex flex-wrap gap-[12px] w-full">
      <SpellsTable className="flex-[1_1_350px]" data={summoner_spells} />
      <AbilitiesTable className="flex-[1_1_350px]" championId={championId} data={skills} />
    </div>
  );
}
